import Admin from "../Admin";
import React from "react";
import CardAdminDistributionReasonList from "../../../Component/Card/Admin/DistributionReason/CardAdminDistributionReasonList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminDistributionReasonList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminDistributionReasonList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/distributionReason",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Distribution Reasons" buttons={buttons} />;
  }
}
